// @ts-check
import { computed } from 'vue';
import { useGetters } from 'vuex-composition-helpers/dist';

export function usePlans() {
  /** @type {import('@/store/modules/plan').Getters} */
  const { scope } = useGetters({ scope: 'plan/scope' });

  /**
   * @param {string} feature
   * @returns {import('vue').ComputedRef<boolean>}
   */
  function hasAccess(feature) {
    // eslint-disable-next-line arrow-body-style
    return computed(() => {
      return scope.value.includes(feature);
    });
  }

  return {
    hasAPIAccess: hasAccess('plan_api'),
    hasAllowListAccess: hasAccess('plan_allowlist'),
    hasBrandingAccess: hasAccess('plan_branding'),
    hasBulkSendAccess: hasAccess('plan_bulk_send'),
    hasTeamsAccess: hasAccess('plan_team'),
  };
}
